// @flow
import * as React from 'react';
import groupBy from 'lodash/groupBy';
import toPairs from 'lodash/toPairs';
import uniqueId from 'lodash/uniqueId';

import type { Tag } from '~components/EntryTagPopover/types';

export default function useGroupedTags(tags: ?Array<?Tag>) {
  const groupedTags = React.useMemo(() =>
    tags
      ? groupBy<string, *>(tags, tag => tag?.data?.group_category?.text)
      : null,
  );

  const toPairsGroupedTags = toPairs(groupedTags);

  return toPairsGroupedTags.reduce(
    (acc, tagsGroup) => [
      ...acc,
      {
        id: uniqueId(),
        categoryName: tagsGroup[0],
        tags: tagsGroup[1],
      },
    ],
    [],
  );
}
